import React, { useState } from "react";
import * as yup from "yup";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { defaultValue } from "./headers";
import {
  Button,
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@material-ui/core";
import { styles } from "../styles";
import utils from "../../utils/utils";
import { useStateValue } from "../../context/store";

const SearchCertification = ({ maestras, charges }) => {
  const classes = styles();
  const [{}, dispatch] = useStateValue();
  var currentDate = new Date();

  const [minDate, setMinDate] = useState(null);
  const [maxInitDate, setMaxInitDate] = useState(
    utils.getFormattedDateMMddyyyy(currentDate, ".")
  );

  const schema = yup.object().shape({
    firstName: yup
      .string()
      .nullable()
      .notRequired()
      .min(3, "Ingrese mínimo 3 caracteres")
      .max(50, "Ingrese máximo 50 caracteres")
      .matches(/^(([A-Za-zÀ-ÿ])+[ ]?)*$/g, "Ingrese un nombre válido")
      .transform((v) => (v ? v : null)),
    surname: yup
      .string()
      .nullable()
      .notRequired()
      .min(3, "Ingrese mínimo 3 caracteres")
      .max(50, "Ingrese máximo 50 caracteres")
      .matches(/^(([A-Za-zÀ-ÿ])+[ ]?)*$/g, "Ingrese un apellido válido")
      .transform((v) => (v ? v : null)),
    documentType: yup.string().nullable().notRequired(),
    document: yup
      .string()
      .nullable()
      .notRequired()
      .min(3, "Ingrese mínimo 3 caracteres")
      .max(16, "Ingrese máximo 16 caracteres")
      .transform((v) => (v ? v : null)),
    status: yup.string().nullable().notRequired(),
    chargeDenomination: yup.string().nullable().notRequired(),
  });

  const {
    register,
    handleSubmit,
    setValue,
    control,
    errors,
    getValues,
    watch,
  } = useForm({
    resolver: yupResolver(schema),
    defaultValue,
    mode: "all",
    reValidateMode: "onChange",
  });

  const onSubmit = (data) => {
    if (
      data.firstName !== null ||
      data.surname !== null ||
      data.documentType !== null ||
      data.document !== null ||
      data.status !== null ||
      data.chargeDenomination !== null
    ) {
      dispatch({
        type: "SET_FILTER_CERTIFICATE",
        filter: data,
        isFilter: true,
      });
    }
  };

  const handleUserKeyPress = (e) => {
    var form = getValues();
    if (form.documentType !== "PP") {
      let validChars = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"];
      if (!validChars.includes(e.key)) {
        e.preventDefault();
      }
    }
  };

  const clearForm = () => {
    setValue("firstName", null);
    setValue("surname", null);
    setValue("document", null);
    setValue("documentType", null);
    setValue("status", "");
    setValue("initDate", null);
    setMaxInitDate(new Date());
    setMinDate(null);
  };

  const clearBtn = () => {
    clearForm();
    dispatch({
      type: "SET_FILTER_CERTIFICATE",
      filter: {
        email: null,
        firstName: null,
        surname: null,
        documentType: null,
        document: null,
        status: null,
        initDate: null,
        endDate: null,
        chargeDenomination: null,
      },
      isFilter: true,
    });
  };

  return (
    <div style={{ marginBottom: 30 }}>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className={classes.form}
        autocomplete="off"
      >
        <Grid container spacing={2}>
          <Grid item xs={12} md={3} lg={3}>
            <FormControl fullWidth>
              <TextField
                fullWidth
                variant="outlined"
                inputRef={register}
                InputLabelProps={{ shrink: true }}
                className={classes.dropdown}
                type="text"
                autocomplete="off"
                label="Primer Nombre"
                name="firstName"
                size="small"
                error={
                  errors.hasOwnProperty("firstName") &&
                  errors["firstName"].message
                }
              />
              <FormHelperText style={{ color: "#f44336", paddingLeft: 14 }}>
                {errors.hasOwnProperty("firstName") &&
                  errors["firstName"].message}
              </FormHelperText>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={3} lg={3}>
            <FormControl fullWidth>
              <TextField
                fullWidth
                inputRef={register}
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                className={classes.dropdown}
                type="text"
                autocomplete="off"
                label="Primer Apellido"
                name="surname"
                size="small"
                error={
                  errors.hasOwnProperty("surname") && errors["surname"].message
                }
              />
              <FormHelperText style={{ color: "#f44336", paddingLeft: 14 }}>
                {errors.hasOwnProperty("surname") && errors["surname"].message}
              </FormHelperText>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={3} lg={3}>
            <FormControl
              variant="outlined"
              fullWidth
              className={classes.formControlGen}
              size="small"
              error={
                !!errors.hasOwnProperty("documentType") &&
                errors["documentType"].message
              }
            >
              <InputLabel htmlFor="outlined-select-documentType" shrink={true}>
                Tipo de documento *
              </InputLabel>
              <Controller
                fullWidth
                control={control}
                name="documentType"
                inputRef={register}
                defaultValue=""
                className={classes.dropdown}
                label="Cargo a desempeñar *"
                size="small"
                notched={true}
                inputProps={{
                  name: "documentType",
                  id: "outlined-select-documentType",
                }}
                as={
                  <Select>
                    {maestras?.tipoDocumnetoIdentificacion?.map((res) => (
                      <MenuItem
                        className={classes.menuItem}
                        key={res?.key}
                        value={res?.key}
                      >
                        {res?.value}
                      </MenuItem>
                    ))}
                  </Select>
                }
              />
              <FormHelperText style={{ color: "#f44336", paddingLeft: 14 }}>
                {errors.hasOwnProperty("documentType") &&
                  errors["documentType"].message}
              </FormHelperText>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={3} lg={3}>
            <FormControl fullWidth>
              <TextField
                InputLabelProps={{ shrink: true }}
                inputRef={register}
                type="text"
                name="document"
                className={classes.dropdown}
                defaultValue=""
                variant="outlined"
                fullWidth
                size="small"
                label="Número de Documento"
                error={
                  errors.hasOwnProperty("document") &&
                  errors["document"].message
                }
                onKeyPress={handleUserKeyPress}
              />
              <FormHelperText style={{ color: "#f44336", paddingLeft: 14 }}>
                {errors.hasOwnProperty("document") &&
                  errors["document"].message}
              </FormHelperText>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={3} lg={3}>
            <FormControl variant="outlined" fullWidth size="small">
              <InputLabel
                htmlFor="outlined-select-estado"
                shrink={true}
                size="small"
              >
                Estado
              </InputLabel>
              <Controller
                control={control}
                inputRef={register}
                fullWidth
                size="small"
                className={classes.dropdown}
                label="Estado"
                notched={true}
                name="status"
                defaultValue=""
                inputProps={{
                  name: "status",
                  id: "outlined-select-estado",
                }}
                as={
                  <Select>
                    <MenuItem
                      className={classes.menuItem}
                      key={1}
                      value="ACTIVO"
                    >
                      Activo
                    </MenuItem>
                    <MenuItem
                      className={classes.menuItem}
                      key={2}
                      value="INACTIVO"
                    >
                      Inactivo
                    </MenuItem>
                  </Select>
                }
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} md={3} lg={3}>
            <FormControl
              variant="outlined"
              fullWidth
              size="small"
              error={
                !!errors.hasOwnProperty("chargeDenomination") &&
                errors["chargeDenomination"].message
              }
            >
              <InputLabel
                htmlFor="outlined-select-chargeDenomination"
                shrink={true}
              >
                Cargo
              </InputLabel>
              <Controller
                fullWidth
                control={control}
                inputRef={register}
                className={classes.dropdown}
                label="Cargo"
                defaultValue=""
                name="chargeDenomination"
                size="small"
                notched={true}
                inputProps={{
                  name: "chargeDenomination",
                  id: "outlined-select-chargeDenomination",
                }}
                as={
                  <Select>
                    {charges.map((resp) => (
                      <MenuItem
                        className={classes.menuItem}
                        key={resp.id}
                        value={resp.id}
                      >
                        {resp.denomination}
                      </MenuItem>
                    ))}
                  </Select>
                }
              />
              <FormHelperText style={{ color: "#f44336", paddingLeft: 14 }}>
                {errors.hasOwnProperty("chargeDenomination") &&
                  errors["chargeDenomination"].message}
              </FormHelperText>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={3} lg={3}>
            <Button
              variant="contained"
              className={classes.buttonSearch}
              type="submit"
            >
              Buscar
            </Button>
            &nbsp;&nbsp;
            <Button
              variant="contained"
              className={classes.buttonSearch}
              onClick={clearBtn}
            >
              Limpiar
            </Button>
          </Grid>
        </Grid>
      </form>
    </div>
  );
};

export default SearchCertification;
